import { Stack, Typography } from "@mui/material";
import StaticCircularProgress from "@entrilia/shared/components/StaticCircularProgress";

interface Props {
  value: number;
  label?: string;
}

const CompletionPercentageIndicator = ({ value, label }: Props) => (
  <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
    <StaticCircularProgress size={20} value={value} />
    <Typography>
      {value}%{label && ` · ${label}`}
    </Typography>
  </Stack>
);

export default CompletionPercentageIndicator;
